// extracted by mini-css-extract-plugin
module.exports = {"link":"NavBar_link__8D56O","menu":"NavBar_menu__1sEJj","logo":"NavBar_logo__1wBSX"};